import { createSelector } from 'reselect';

export const selectShopsState = (state) => state.shops;

export const selectShopList = createSelector(selectShopsState, (shopsState) => shopsState.shops);

export const shopsSelectors = {
  selectShopsState,
  selectShopList,
};
